/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Configuration for a performance level
 */
export interface PerformanceLevelConfig {
  id: string;
  /**
   * Performance percentage value between 0.0 and 1.0
   * @minimum 0
   * @maximum 1
   */
  performancePercent: number;
  label: string;
  description: string;
}
